import VimeoUpload from "vimeo-upload";
import axios from 'axios';

export default class VimeoUploader {
  constructor({ accessToken }) {
    this.accessToken = accessToken;

  }

  uploadVideo(file, onProgress, onSuccess, onError, onStatusChange, afterUpload) {
    const uploader = new VimeoUpload({
      name: file.name.replace(/\.[^/.]+$/, ""),
      file: file,
      token: this.accessToken,
      onError: (error) => {
        const errorMessage = JSON.parse(error).error;
        onError && onError(errorMessage);
      },
      onProgress: (data) => {
        const progress = Math.floor((data.loaded / data.total) * 100);
        onProgress && onProgress(progress);
      },
      onComplete: (videoId) => {
        afterUpload && afterUpload(videoId);
        this._processVideo(videoId, onSuccess, onError, onStatusChange);
      },
    });

    uploader.upload();
  }

  async _processVideo(videoId, onSuccess, onError, onStatusChange) {
    try {
      let transcodeStatus;
      do {
        transcodeStatus = await this._checkTranscodeStatus(videoId);
        onStatusChange && onStatusChange(transcodeStatus);

        if (transcodeStatus !== "complete") {
          await this._delay(8000); // Polling delay for transcoding
        }
      } while (transcodeStatus !== "complete");

      const hlsFile = await this._fetchHlsFile(videoId);
      if (!hlsFile) {
        onError && onError("HLS file not found");
        return;
      }

      const thumbnailUrl = await this._fetchThumbnailUrl(videoId);
      if (!thumbnailUrl) {
        onError && onError("Thumbnail not found");
        return;
      }

      onSuccess && onSuccess({
        hlsUrl: hlsFile.link_secure,
        thumbnailUrl: thumbnailUrl,
      });
    } catch (error) {
      onError && onError(error.message || "An error occurred");
    }
  }

  async _checkTranscodeStatus(videoId) {
    const response = await axios.get(
      `https://api.vimeo.com/me/videos/${videoId}?fields=transcode`,
      {
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
        },
      }
    );

    return response.data.transcode.status;
  }

  async _fetchHlsFile(videoId) {
    const response = await axios.get(
      `https://api.vimeo.com/me/videos/${videoId}?fields=files`,
      {
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
        },
      }
    );

    const hlsFile = response.data.files.find(file => file.quality === "hls");

    if (!hlsFile) {
      await this._delay(10000); // Polling delay for HLS file availability
      return this._fetchHlsFile(videoId);
    }

    return hlsFile;
  }

  async _fetchThumbnailUrl(videoId) {
    const response = await axios.get(
      `https://api.vimeo.com/me/videos/${videoId}?fields=pictures.sizes`,
      {
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
        },
      }
    );

    const sizes = response.data.pictures.sizes;
    const thumbnailUrl = sizes.length ? sizes[sizes.length - 1].link : null;

    return thumbnailUrl;
  }

  _delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
